function isBlankLocation(location, suggestedNickname) {
    const { addressName = '', ...fields } = location;
    const nickname = addressName.trim();
    return ((nickname === '' || nickname === suggestedNickname) &&
        Object.values(fields).every((value) => (value ?? '').trim() === ''));
}
/** True when nothing but the auto-suggested nicknames is filled in, so a new customer or vendor gets no address. */
export function isBlankAddressPairForm(values, pair) {
    const shipping = {
        addressName: values.addressName,
        address: values.address,
        city: values.city,
        stateId: values.stateId,
        countryId: values.countryId,
        zip: values.zip,
    };
    return (isBlankLocation(shipping, pair.shippingNickname) &&
        (values[pair.sameAsField] !== false ||
            isBlankLocation(values[pair.secondaryField] ?? {}, pair.secondaryNickname)));
}
//# sourceMappingURL=is-blank-address-pair-form.js.map